<template>
  <div class="statistics-pg">
    <Search/>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="position">
        <div class="bg-white p-20">
          <h1 class="title-pg">{{ $t('Статистика портала') }}</h1>
          <v-list-item
            v-bind:key="s.text"
            v-for="s in statistics"
          >
            <v-list-item-title>
              <template v-if="s.href">
                <a :href="s.href">
                  {{ s.text }}
                </a>
              </template>
              <template v-else>
                {{ s.text }}
              </template>
            </v-list-item-title>
          </v-list-item>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Search from '@/components/Search'
import {mapMutations} from 'vuex'
import {Trans} from "@/plugins/Translation"
import mixin from '@/plugins/mixin/mixin'

export default {
  mixins: [mixin],
  components: {
    Search
  },
  data: () => ({
    breadcrumbs: [],
    statistics: []
  }),
  metaInfo() {
    return {
      title: this.$i18n.t('StatisticsTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('StatisticsDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('StatisticsKeywordsSEO'),
      }]
    }
  },
  mounted() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.breadcrumbs = [
        {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
        {text: this.$i18n.t('Статистика портала'), disabled: true}
      ]
      this.statistics = [
        {text: this.$i18n.t('Статистика по разработчикам проектов НПА'), href: Trans.currentLocaleUrl + '/developer-statistics'},
        {text: this.$i18n.t('Статистика по категориям'), href: Trans.currentLocaleUrl + '/category-statistics' },
        // {text: this.$i18n.t('Общая посещаемость портала') }
      ]
      this.setLoading(false)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
  }
}
</script>
